module.exports = __webpack_public_path__ + "static/media/avtar.d0bed13e.JPG";